/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     客户数据管理
  +--------------------------------------------------------------------------------------
*/

import Vue from 'vue'
import { postGodInfoApi, postGodSettingApi } from '@/api/fam/famGodApi'

const godStore = {
  state: {
  },

  mutations: {
    SET_GOD: (state, god) => {
      Object.keys(god).forEach((item) => {
        Vue.set(state, item, god[item])
      })

      // 个性化设置更新
      if (god.customization) {
        // if (god.customization.login_bg_imgurl) {
        //   localStorage.setItem('__LOGIN_BG__', god.customization.login_bg_imgurl)
        // }
        if (god.customization.console_imgurl) {
          localStorage.setItem('__CONSOLE_IMGURL__', god.customization.console_imgurl)
          // 更新favicon
          var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
          link.type = 'image/x-icon'
          link.rel = 'icon'
          link.href = god.customization.console_imgurl
          document.getElementsByTagName('head')[0].appendChild(link)
        }
        if (god.customization.console_title) {
          // localStorage.setItem('__LOGIN_TITLE__', god.customization.console_title)
          localStorage.setItem('__CONSOLE_TITLE__', god.customization.console_title)
          // 更新页眉
          document.title = god.customization.console_title
        }
      }
    },
  },

  actions: {
    // 设置客户信息
    setGodInfoAction({ commit, state, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        postGodInfoApi(formData).then(res => {
          if (!res.errno) {
            dispatch('getUserInfoAction').then(() => {})
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    // 设置客户个性化
    setGodCustomizationAction({ commit, state, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        postGodSettingApi(formData).then(res => {
          if (!res.errno) {
            dispatch('getCustomizationInfoAction').then(() => {})
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

  }
}

export default godStore
